import ImageCarousel from "../../Components/Common/Carousel";
import EstandeSemImagem from "../../assets/images/estande_sem_imagem.png";
import DimensoesTable from "../ComponenteCompartilhado/DimensoesTable";
import ValoresTable from "../ComponenteCompartilhado/ValoresTable";
import "../../assets/scss/vendas/vendas.scss";

const SidebarEstandeRenovacaoDados = ({
  selectedEstandeInfo,
  corPrincipal,
  isMobile,
  setOpenMobile,
  corSecundaria,
  onToggle,
  label
}) => {

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  return (
    <div className="sidebar-renovacao-dados" style={{ "--primary-color": corPrincipal, "--second-color": corSecundaria }}>
      {!!onToggle && (
        <div className={`sidebar-backdrop ${isOpen ? "is-visible" : ""}`} onClick={onToggle} />
      )}
      
      <div className="sidebar-renovacao-dados__header">
        {isMobile && typeof setOpenMobile === "function" && (
          <button
            onClick={() => setOpenMobile(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "transparent",
              border: "none",
              fontSize: 26,
              color: "white",
              zIndex: 20,
            }}
            aria-label="Fechar"
            title="Fechar"
          >
            ×
          </button>
        )}
        
        <h4 style={{ color: 'white'}} >{selectedEstandeInfo?.nome || ""} {label}</h4>
        {selectedEstandeInfo?.pavilhao.length > 0 && (
          <span style={{ color: 'white'}}>{selectedEstandeInfo?.pavilhao[0].nome}</span>
        )}
         
      </div>

      <div className="sidebar-renovacao-dados__body">
        <ImageCarousel 
          images={selectedEstandeInfo?.imagens || []} 
          defaultImage={EstandeSemImagem}
          corFundo={corPrincipal}
        />
 
        <DimensoesTable selectedEstandeInfo={selectedEstandeInfo} corPrincipal={corPrincipal} />

        {selectedEstandeInfo?.tags?.length > 0 && (
          <div style={{marginTop: "0.5rem" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px", color: "#464373" }}>
              INCLUSOS
            </h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              {selectedEstandeInfo.tags.map((tag, index) => (
                <div key={index} style={{
                  background: "#4643737a",
                  borderRadius: "10px",
                  padding: "6px 12px",
                  minWidth: "fit-content"
                }}>
                  <p style={{ color: "#fff", fontSize: "12px", fontWeight: 500, marginBottom: 0, whiteSpace: "nowrap" }}>
                    {tag.nome}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {selectedEstandeInfo?.observacao && (
          <div style={{ marginTop: "0.5rem" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px", color: "#464373" }}>
              OBSERVAÇÕES
            </h3>
            <div style={{ background: "#f7f7f7", padding: "1rem", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.15) 1px 2px 2px 1px" }}>
              <p style={{ color: "#878A99", marginBottom: 0 }}>
                {selectedEstandeInfo.observacao}
              </p>
            </div>
          </div>
        )}

        {selectedEstandeInfo?.valor_total_geral && (
          <div style={{ marginTop: "0.5rem" }}>
            <h3 style={{ 
              fontSize: "14px", 
              fontWeight: 600, 
              letterSpacing: "1px", 
              marginBottom: "10px", 
              color: "#464373" 
            }}>
              VALOR TOTAL: {formatCurrency(selectedEstandeInfo.valor_total_geral)}
            </h3>
            <ValoresTable selectedEstandeInfo={selectedEstandeInfo} />
          </div>
        )}

      </div>


    
    </div>

  );
};

export default SidebarEstandeRenovacaoDados;